import io from 'socket.io-client'

let socket = null

export default {
  connect (token) {
    if (!token) return null
    if (socket && socket.connected) return socket
    socket = io(process.env.VUE_APP_SOCKET_URL || 'http://127.0.0.1:3334', {
      auth: { token },
      transports: ['websocket', 'polling']
    })
    return socket
  },
  disconnect () {
    if (socket) socket.disconnect()
    socket = null
  },
  joinRequest (requestId) {
    if (socket && requestId) socket.emit('request:join', { requestId })
  },
  sendRequestMessage (requestId, payload, callback) {
    if (!socket || !socket.connected) return false
    const body = typeof payload === 'string' ? { text: payload } : payload
    socket.emit('request:message:new', { requestId, ...body }, callback)
    return true
  },
  onMessageCreated (handler) {
    if (socket) socket.on('request:message:created', handler)
  },
  onRequestUpdated (handler) {
    if (socket) socket.on('request:updated', handler)
  },
  offMessageCreated (handler) {
    if (socket) socket.off('request:message:created', handler)
  },
  offRequestUpdated (handler) {
    if (socket) socket.off('request:updated', handler)
  }
}
